import * as constants from "../constants/CONSTANT";
import { getAxios, getAxiosMultipart } from "../utils/helper";
import { ToastContainer } from "react-bootstrap";
import { toast } from "react-toastify";
<ToastContainer
  position="top-right"
  autoClose={2000}
  hideProgressBar={false}
  newestOnTop={false}
  closeOnClick
  rtl={false}
  pauseOnFocusLoss
  draggable
  pauseOnHover
  theme="light"
/>;
const formatLocalDateForApi = (value) => {
  if (!value) return value;

  if (typeof value === "string") {
    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
    const parsed = new Date(value);
    if (!isNaN(parsed)) {
      const year = parsed.getFullYear();
      const month = String(parsed.getMonth() + 1).padStart(2, "0");
      const day = String(parsed.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    }
    return value;
  }

  if (value instanceof Date && !isNaN(value)) {
    const year = value.getFullYear();
    const month = String(value.getMonth() + 1).padStart(2, "0");
    const day = String(value.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const parsed = new Date(value);
  if (!isNaN(parsed)) {
    const year = parsed.getFullYear();
    const month = String(parsed.getMonth() + 1).padStart(2, "0");
    const day = String(parsed.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  return value;
};

const schoolApi = {
  async handleUnauthorized(method) {
    try {
      return await method();
    } catch (error) {
      if (
        error.response &&
        (error.response.status === 401 || error.response.status === 403)
      ) {
        const errMsg = error.response.data?.errors || error.response.data?.message;
        sessionStorage.clear();
        localStorage.clear();
        if (errMsg === "This user has been deactivated by the Admin. Please contact your Admin.") {
          alert(errMsg);
        }
        window.location.href = "/login";
      } else {
        console.error("Error:", error);
        throw error;
      }
    }
  },

  async updateallSettings(settingsRecord) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();

      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/settings/updateall/"}`,
        settingsRecord
      );
      return data;
    });
  },
  async getAllSetting() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/settings/"}`
      );
      return data;
    });
  },

  async getFeeReconciliationData(reportData) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/demands/reconciliation/${reportData.session_id}`
      );

      if (data.length > 0) {
        return data;
      } else {
        return data;
      }
    });
  },

  async getDemandCalculations(session_id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/demands/${session_id}`
      );
      return data;
    });
  },

  async getAllStudentByClassidFeeData(reportData) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const params = {};
      if (reportData.start_date) params.startdate = reportData.start_date;
      if (reportData.end_date) params.enddate = reportData.end_date;
      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/reports/students/${reportData.classid ? reportData.classid : null
        }/${reportData.session_id}/${reportData.section_id ? reportData.section_id : null
        }`,
        { params }
      );

      if (data.length > 0) {
        return data;
      } else {
        return data;
      }
    });
  },

  async fetchUsers() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/auth/users/all"}`
      );
      if (data.length > 0) {
        return data;
      }
    });
  },

  async urlToDataUrl(img) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/files/company/logoimg`
      );
      return data;
    });
  },

  async fetchStaffById(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/auth/${id}`
      );
      return data;
    });
  },

  async getLoginUserData() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/auth/getuser`
      );
      return data;
    });
  },

  async saveStaffMember(staffMember) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL}/api/auth/${staffMember.id}`
      );
      return data;
    });
  },

  async saveUser(user) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL}/api/auth/${user.id}`,
        user
      );
      return data;
    });
  },

  async saveStaffMemberEditProfile(userid, selectedFiles, staffMember) {
    return await this.handleUnauthorized(async () => {
      console.log(
        "====>>>  userid, selectedFiles, staffMember",
        userid,
        selectedFiles,
        staffMember
      );
      const formData = new FormData();
      formData.append("file", selectedFiles);
      formData.append("staffRecord", staffMember);
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL}/api/auth/profile/${userid}`,
        formData
      );
      return data;
    });
  },

  async deleteUser(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.delete(
        `${constants.API_BASE_URL}/api/auth/${id}`
      );
      return data;
    });
  },

  async createContact(student) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL}/api/contacts`,
        student
      );
      return data;
    });
  },

  async createContactParent(parent) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL}/api/contacts`,
        parent
      );
      return data;
    });
  },

  async updateStudent(student) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL}/api/students/${student.studentid}`,
        student
      );
      return data;
    });
  },

  async updateParentContact(parent) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL}/api/contacts/${parent.id}`,
        parent
      );
      return data;
    });
  },

  async updateContactById(familyInfo) {
    return await this.handleUnauthorized(async () => {
      try {
        const instance = getAxios();
        const { data } = await instance.put(
          `${constants.API_BASE_URL}/api/contacts/fatherid/${familyInfo.father_id}/motherid/${familyInfo.mother_id}/guardianid/${familyInfo.guardian_id}`,
          familyInfo
        );
        return data;
      } catch (error) {
        console.error("Error updating contact:", error);
        throw error;
      }
    });
  },

  async createStudent(student) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        constants.API_BASE_URL + "/api/students/",
        student
      );
      return data;
    });
  },

  async createSession(sessionData) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        constants.API_BASE_URL + "/api/sessions/session",
        sessionData
      );
      return data;
    });
  },

  async getAllSession() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();

      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/sessions/session"}`
      );

      return data;
    });
  },
  async getAllSettings() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/settings/"}`
      );
      return data;
    });
  },

  async getSettingByKey(key) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/settings/" + key}`
      );
      return data;
    });
  },

  async createSettings(settingsRecord) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/settings/"}`,
        settingsRecord
      );
      return data;
    });
  },

  async updateSettings(id, settingsRecord) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/settings/" + id}`,
        settingsRecord
      );
      return data;
    });
  },

  async deleteSettings(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.delete(
        `${constants.API_BASE_URL + "/api/settings/" + id}`
      );
      return data;
    });
  },

  async getSessionById(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/sessions/session/" + id}`
      );

      if (data.success) {
        return data;
      }
    });
  },

  async updateSession(id, sessionData) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/sessions/session/" + id}`,
        sessionData
      );
      return data;
    });
  },

  async deleteSession(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.delete(
        `${constants.API_BASE_URL + "/api/sessions/session/" + id}`
      );
      return data;
    });
  },

  async saveContact(contact) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/contacts/" + contact.id}`,
        contact
      );

      return data;
    });
  },
  async fetchStaffContactsName(flaterData) {
    return await this.handleUnauthorized(async () => {
      try {
        const instance = getAxios();
        let empName = flaterData?.name ? flaterData?.name : "undefined";
        let recordType = flaterData?.recordtype
          ? flaterData?.recordtype
          : "undefined";
        const { data } = await instance.get(
          `${constants.API_BASE_URL}/api/contacts/filter/flaterData/${empName}/${recordType}`
        );
        return data;
      } catch (error) {
        console.error("Error fetching staff contacts:", error);
        throw error;
      }
    });
  },

  async fetchStaffContacts() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();

      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/contacts/staff/filter"}`
      );
      return data;
    });
  },

  async fetchStudents() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/students"}`
      );

      return data;
    });
  },

  async fetchAllRteStudents() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/studentaddmissions/getrte"}`
      );
      if (data.length > 0) {
        return data;
      }
    });
  },

  async fetchParentContacts() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/contacts/parent"}`
      );

      return data;
    });
  },

  async fetchContact(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/contacts/parentbyid/" + id}`
      );
      return data;
    });
  },

  async fetchChildByParentId(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();

      try {
        const { data } = await instance.get(
          `${constants.API_BASE_URL}/api/contacts/getchild/${id}`
        );

        return data;
      } catch (error) {
        console.error(`Error fetching child contacts: `, error);
        throw error;
      }
    });
  },

  async fetchStudentbyId(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/students/sibling/" + id}`
      );
      return data;
    });
  },
  async fetchStudentbyClassId(classid) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/students/class/" + classid}`
      );
      return data;
    });
  },
  async fetchStudentAddmissionbyClassId(classid) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/students/addmission/class/" + classid
        }`
      );
      return data;
    });
  },
  async fetchStudentbySRNumber(srnumber) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/students/srnumber/" + srnumber}`
      );
      return data;
    });
  },

  async fetchStudentByParentId(contIds) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/students/parent/" + contIds}`
      );
      return data;
    });
  },

  async fetchStudentRteId(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/students/rte/" + id}`
      );
      return data;
    });
  },

  async deleteContactStudent(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.delete(
        `${constants.API_BASE_URL + "/api/contacts/" + id}`
      );

      return data;
    });
  },

  async fetchCountOfStudents() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/contacts/total/students"}`
      );
      if (data.length > 0) {
        return data;
      }
    });
  },

  async fetchCountOfStaffs() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/contacts/total/staff"}`
      );
      if (data.length > 0) {
        return data;
      }
    });
  },

  async fetchCountOfParents() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/contacts/total/parents"}`
      );
      if (data.length > 0) {
        return data;
      }
    });
  },

  async fetchCountOfClasses() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/classes/total/class"}`
      );
      if (data.length > 0) {
        return data;
      }
    });
  },

  async deleteContact(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.delete(
        `${constants.API_BASE_URL + "/api/contacts/" + id}`
      );
      return data;
    });
  },

  async deleteStudent(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.delete(
        `${constants.API_BASE_URL + "/api/students/" + id}`
      );
      return data;
    });
  },

  async uploadCSVFile(formData) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxiosMultipart();
      try {
        const response = await instance.post(
          `${constants.API_BASE_URL + "/api/attendances/upload"}`,
          formData
        );
        if (response.data) {
          return response;
        }
      } catch (error) {
        console.error("uploadCSVFile error => ", error);
      }
    });
  },

  async getAllSyllabus() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/syllabus/getallsyllabus"}`
      );

      if (data.length > 0) {
        return data;
      }
    });
  },

  async createSyllabus(syllabus) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/syllabus/"}`,
        syllabus
      );

      return data;
    });
  },

  async updateSyllabus(id, syllabus) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/syllabus/" + id}`,
        syllabus
      );
      return data;
    });
  },

  async deleteSyllabus(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.delete(
        `${constants.API_BASE_URL + "/api/syllabus/" + id}`
      );
      return data;
    });
  },

  async createSubject(subject) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/subjects/"}`,
        subject
      );
      return data;
    });
  },

  async saveSubject(subject) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/subjects/" + subject.id}`,
        subject
      );
      return data;
    });
  },

  async fetchSubject() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/subjects/active"}`
      );

      return data;
    });
  },

  async fetchSubjectById(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/subjects/" + id}`
      );
      return data;
    });
  },

  async fetchAssignSubjectClass() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/assignsubjectclass"}`
      );
      if (data.length > 0) {
        return data;
      }
    });
  },

  async createAssignSubjectClass(assignSubjectClass) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/assignsubjectclass"}`,
        assignSubjectClass
      );
      return data;
    });
  },

  async deleteAssignSubjectClass(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.delete(
        `${constants.API_BASE_URL + "/api/assignsubjectclass/" + id}`
      );
      return data;
    });
  },

  async getAllRecords(classname) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL +
        "/api/assignsubjectclass/add/edit/" +
        classname
        }`
      );
      if (data.length > 0) {
        return data;
      }
    });
  },

  async fetchSectionRecords() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/section/"}`
      );

      if (data.length > 0) {
        return data;
      }
    });
  },

  async fetchSectionRecordsWithClassId(ClassId) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/section/" + ClassId}`
      );

      if (data.length > 0) {
        return data;
      }
    });
  },

  async addSectionRecord(body) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/section/add"}`,
        body
      );
      return data;
    });
  },

  async getAllFeesDemand(sessionid) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/reports/getallfeesdemands/${sessionid}`
      );
      return data;
    });
  },

  async getDemands(sessionid) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/demand/${sessionid}`
      );
      return data;
    });
  },

  async updateSectionRecord(sectionRecords) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();

      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/section/" + sectionRecords.id}`,
        sectionRecords
      );

      return data;
    });
  },

  async updateSectionActiveRecord(sectionRecords) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL +
        "/api/section/active/" +
        sectionRecords.section_id
        }`,
        sectionRecords
      );
      return data;
    });
  },

  async fetchRecordById(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/section/" + id}`
      );
      return data;
    });
  },

  async fetchTeacherRecords() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/section/teacher/abc"}`
      );

      if (data.length > 0) {
        return data;
      }
    });
  },
  async fetchParentsInfoByPhone(phone) {
    return await this.handleUnauthorized(async () => {
      try {
        const instance = getAxios();
        const { data } = await instance.get(
          `${constants.API_BASE_URL}/api/contacts/parent/${phone}`
        );
        return data;
      } catch (error) {
        if (error) {
          return { message: "Parent not found" };
        }
        throw error;
      }
    });
  },

  async fetchSections() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/section/"}`
      );

      if (data.length > 0) {
        return data;
      }
    });
  },

  async deleteSection(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.delete(
        `${constants.API_BASE_URL + "/api/section/" + id}`
      );
      return data;
    });
  },

  async createFile(parentId, selectedFiles) {

    console.log('selectedFiles-on scholapi->', selectedFiles);
    return await this.handleUnauthorized(async () => {
      const token = sessionStorage.getItem("token");
      let response = await fetch(
        constants.API_BASE_URL + "/api/files/" + parentId,
        {
          method: "POST",
          mode: "cors",
          headers: {
            Authorization: token,
          },
          body: selectedFiles,
        }
      );
      const result = await response.json();
      return result;
    });
  },
  async createFileForPublic(selectedFiles) {
    return await this.handleUnauthorized(async () => {
      const token = sessionStorage.getItem("token");
      let response = await fetch(
        constants.API_BASE_URL + "/api/files/upload/file",
        {
          method: "POST",
          mode: "cors",
          headers: {
            Authorization: token,
          },
          body: selectedFiles,
        }
      );
      const result = await response.json();
      return result;
    });
  },

  async fetchFiles(parentid) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(`${constants.API_BASE_URL}/api/files/${parentid}/all`);
      return data;
    });
  },

  async downloadFiles(file) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      try {
        const response = await instance.get(
          `${constants.API_BASE_URL}/api/files/${file}/download`,
          { responseType: "blob" } // Important for binary data
        );

        return response.data;
      } catch (error) {
        console.error("Error fetching filtered student data:", error);
        throw error;
      }
    });
  },

  async saveFiles(fileId, formData) {
    return await this.handleUnauthorized(async () => {
      const token = sessionStorage.getItem("token");
      let response = await fetch(
        constants.API_BASE_URL + "/api/files/" + fileId,
        {
          method: "PUT",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: formData,
        }
      );

      return await response.json();
    });
  },

  async deleteFile(id) {
    return await this.handleUnauthorized(async () => {
      const token = sessionStorage.getItem("token");
      let response = await fetch(constants.API_BASE_URL + "/api/files/" + id, {
        method: "DELETE",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      });
      return await response.json();
    });
  },

  async saveStudentAttendance(records, id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/studentattendances/" + id}`,
        records
      );
      return data;
    });
  },
  async fetchFilterdstudent(query) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      try {
        const { data } = await instance.get(
          `${constants.API_BASE_URL}/api/studentattendances/` + query
        );
        return data;
      } catch (error) {
        console.error("Error fetching filtered student data:", error);
        throw error;
      }
    });
  },
  async createstudentAttendance(attandanceRecord) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/studentattendances/"}`,
        attandanceRecord
      );
      return data;
    });
  },

  async createlead(lead) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/leads/"}`,
        lead
      );
      return data;
    });
  },

  async savelead(lead) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/leads/" + lead.id}`,
        lead
      );
      return data;
    });
  },

  async fetchlead() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/leads/"}`
      );

      return data;
    });
  },

  async fetchleadById(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/leads/" + id}`
      );
      return data;
    });
  },

  async deletelead(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.delete(
        `${constants.API_BASE_URL + "/api/leads/" + id}`
      );
      return data;
    });
  },

  async getTeacherRecords(category) {
    try {
      return await this.handleUnauthorized(async () => {
        const instance = getAxios();
        const { data } = await instance.get(
          `${constants.API_BASE_URL}/api/contacts/teacher/category/${category}`
        );

        if (data) {
          return data;
        }
      });
    } catch (error) {
      console.error(
        "Error creating student:",
        error.response?.data || error.message || error
      );
      return error.response?.data;
    }
  },

  async getSubjectRecord() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/subjects"}`
      );

      return data;
    });
  },

  async getSubjectRecordById(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/subjects/" + id}`
      );
      return data;
    });
  },

  async getSubjectRecordName(ObjFilter) {
    return await this.handleUnauthorized(async () => {
      let status = ObjFilter?.status ? ObjFilter?.status : "undefined"; // Add by Aamir khan 15-04-2024
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL +
        "/api/subjects/search/" +
        status +
        "/" +
        ObjFilter?.type
        }` // Add by Aamir khan 15-04-2024
      );

      return data;
    });
  },

  async addSubjectRecord(subject) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/subjects"}`,
        subject
      );
      return data;
    });
  },

  async updateSubjectRecord(subject) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/subjects/" + subject.id}`,
        subject
      );
      return data;
    });
  },

  async deleteSubjectRecord(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.delete(
        `${constants.API_BASE_URL + "/api/subjects/" + id}`
      );
      return data;
    });
  }, // subjects || END

  async getAssignSubjectClassRecords() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/assignsubjectclass"}`
      );
      return data;
    });
  },

  async addAssignSubjectClassRecord(record) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/assignsubjectclass"}`,
        record
      );
      return data;
    });
  },

  async getAssignSubjectClassIdByRecords(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/assignsubjectclass?class_id=" + id}`
      );

      return data;
    });
  },

  async deleteAssignSubjectClassRecord(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.delete(
        `${constants.API_BASE_URL + "/api/assignsubjectclass/" + id}`
      );
      return data;
    });
  },

  async getSectionRecords() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/section"}`
      );

      if (data) {
        return data;
      }
    });
  },

  async addSectionRecord(body) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/section/add"}`,
        body
      );
      return data;
    });
  },

  async updateSectionRecord(sectionRecords) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/section/" + sectionRecords.id}`,
        sectionRecords
      );
      return data;
    });
  },

  async updateSectionActiveRecord(sectionRecords) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL +
        "/api/section/active/" +
        sectionRecords.section_id
        }`,
        sectionRecords
      );
      return data;
    });
  },

  async getClassRecordsWithSections(category) {
    try {
      return await this.handleUnauthorized(async () => {
        const instance = getAxios();
        const { data } = await instance.get(
          `${constants.API_BASE_URL}/api/section/class/category/${category}`
        );
        if (data) {
          return data;
        }
      });
    } catch (error) {
      console.error(
        "Error creating student:",
        error.response?.data || error.message || error
      );
      return error.response?.data;
    }
  },
  async getClassRecords() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/classes"}`
      );

      return data;
    });
  },
  async getActiveClassRecords() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/classes/active"}`
      );

      return data;
    });
  },

  async addClassRecord(records) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/classes/add"}`,
        records
      );
      return data;
    });
  },

  async updateClassRecord(records) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/classes/" + records.id}`,
        records
      );

      return {
        ...data,
        updatedRecord: records,
      };
    });
  },

  async createFaremaster(formData) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/faremaster/fare"}`,
        formData
      );
      return data;
    });
  },

  async updateFareMaster(fareIdToUpdate, updatedFareData) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const url = `${constants.API_BASE_URL}/api/faremaster/fare/${fareIdToUpdate}`;

      const { data } = await instance.put(url, updatedFareData);
      return data;
    });
  },

  async getAllFares() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/faremaster/fare`
      );
      return data;
    });
  },

  async fetchFareById(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/faremaster/fare/" + id}`
      );
      return data;
    });
  },

  async deleteFare(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.delete(
        `${constants.API_BASE_URL + "/api/faremaster/fare/" + id}`
      );
      return data;
    });
  },

  async createLocationmaster(formData) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/locationmaster/location"}`,
        formData
      );
      return data;
    });
  },

  async getAllLocation() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/locationmaster/location`
      );
      return data;
    });
  },

  async fetchLocationById(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/locationmaster/location/" + id}`
      );
      return data;
    });
  },

  async deleteLocation(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.delete(
        `${constants.API_BASE_URL + "/api/locationmaster/location/" + id}`
      );
      return data;
    });
  },

  async updateLocationMaster(locationMasterId, formData) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const url = `${constants.API_BASE_URL}/api/locationmaster/location/${locationMasterId}`;
      const { data } = await instance.put(url, formData);
      return data;
    });
  },

  async createVehicle(formData) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/transportation/vehicles"}`,
        formData
      );
      return data;
    });
  },

  async vehicleById(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/transportation/vehicles/${id}`
      );
      return data;
    });
  },

  async updateVehicle(vehicleId, formData) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const url = `${constants.API_BASE_URL}/api/transportation/vehicles/${vehicleId} `;
      const { data } = await instance.put(url, formData);
      return data;
    });
  },

  async getAllVehicles() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/transportation/vehicles"} `
      );
      return data;
    });
  },

  async deleteVehicle(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.delete(
        `${constants.API_BASE_URL + "/api/transportation/vehicles/" + id} `
      );
      return data;
    });
  },

  async fetchDrivers() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/contacts/driver"}`
      );
      return data;
    });
  },

  async createAssignTransport(record) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/assigntransport"}`,
        record
      );
      return data;
    });
  },

  async updateAssignTransport(id, transport) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/assigntransport/" + id}`,
        transport
      );

      return data;
    });
  },

  async deleteAssignTransport(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.delete(
        `${constants.API_BASE_URL + "/api/assigntransport/" + id}`
      );
      return data;
    });
  },

  /* updated API calling by sarfraj | 21-Feb-2025 */
  async getAssignTransportByIdOrStudentid(record, sessiond) {
    return await this.handleUnauthorized(async () => {
      const id = record;
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/assigntransport/id/" + id + "/" + sessiond}`
      );
      return data;
    });
  },

  async fetchExamTitles(session_id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/exams/examtitle`
      );
      return data;
    });
  },

  async checkOldPassword(id, password) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/auth/checkOldPassword`,
        { params: { id, password } }
      );
      return data;
    });
  },

  async updateProfile(record) {
    console.log("updateProfile == ", record)
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL}/api/auth/${record.id}`,
        record
      );
      return data;
    });
  },

  async createExamTitle(newTitle) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/exams/examtitle"}`,
        newTitle
      );
      return data;
    });
  },

  async updateExamTitle(id, newTitle) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/exams/examtitle/" + id}`,
        newTitle
      );

      return data;
    });
  },

  async fetchSessions() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/sessions/session"}`
      );
      return data;
    });
  },

  async fetchExamSchedules() {
    try {
      return await this.handleUnauthorized(async () => {
        const instance = getAxios();
        const { data } = await instance.get(
          `${constants.API_BASE_URL + "/api/exams/examschedule"}`
        );

        return data;
      });
    } catch (error) {
      console.error("Error creating exam schedule:", error);
      throw error;
    }
  },

  async fetchExamSchedulesById(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + `/api/exams/examschedule/${id}`}`
      );

      return data;
    });
  },

  async createExamSchedule(newSchedule) {
    try {
      return await this.handleUnauthorized(async () => {
        const instance = getAxios();
        const response = await instance.post(
          `${constants.API_BASE_URL}/api/exams/examschedule`,
          newSchedule
        );

        return response;
      });
    } catch (error) {
      console.error("Error creating exam schedule:", error);
      throw error;
    }
  },

  async updateExamSchedule(id, updatedSchedule) {
    try {
      return await this.handleUnauthorized(async () => {
        const instance = getAxios();
        const { data } = await instance.put(
          `${constants.API_BASE_URL + "/api/exams/examschedule/" + id}`,
          updatedSchedule
        );

        return data;
      });
    } catch (error) {
      console.error("Error creating exam schedule:", error);
      throw error;
    }
  },


  async fetchRelatedRecords(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        // `${constants.API_BASE_URL + "/api/exams/relatedrecords/"}`
        `${constants.API_BASE_URL}/api/exams/relatedrecords/${id ? id : ""}`
      );

      return data;
    });
  },

  async deleteSchedule(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.delete(
        `${constants.API_BASE_URL + "/api/exams/examschedule/" + id}`
      );
      return data;
    });
  },

  async deleteTitle(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.delete(
        `${constants.API_BASE_URL + "/api/exams/examtitle/" + id}`
      );
      return data;
    });
  },

  async createResult(newResult) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();

      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/results/create_result"}`,
        newResult
      );

      return data;
    });
  },

  async updateResult(resultIdArr) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/results/upsert-records"}`,
        resultIdArr
      );

      return data;
    });
  },

  async fetchStudentsByIds(classid, scheduleid, section_id, session_id) {
    console.log(
      "sectionid findd=>",
      classid,
      "====",
      scheduleid,
      "=======",
      section_id,
      "=========",
      session_id
    );
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL +
        `/api/results/students/${classid}/${scheduleid}/${section_id}/${session_id}`
        }`
      );
      return data;
    });
  },

  async fetchAttendanceFilterData(student_id, session_id) {
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL}/api/attendance_line_item/student_id/${student_id}/session_id/${session_id}`
    );
    return data;
  },

  async getEventsBySession_id(session_id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/events/session_id/" + session_id}`
      );
      return data;
    });
  },

  async createEvent(event) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      try {
        const { data } = await instance.post(
          `${constants.API_BASE_URL + "/api/events/"}`,
          event
        );
        return data;
      } catch (error) {
        console.error("Error creating event:", error);
        throw error;
      }
    });
  },

  async getAllEvents() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/events/getallevents"}`
      );

      if (data.length > 0) {
        return data;
      }
    });
  },

  async updateEvent(id, event) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/events/" + id}`,
        event
      );
      return data;
    });
  },

  async deleteEvent(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.delete(
        `${constants.API_BASE_URL + "/api/events/" + id}`
      );
      return data;
    });
  },

  async getAllStudentByClassidAndSessionid(reportData) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/reports/${reportData.classid}/${reportData.session_id}`
      );

      if (data.length > 0) {
        return data;
      } else {
        return data;
      }
    });
  },

  async fetchStudentBooksMontly(reportData) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      let uri = `/api/demands/bookmonthlysubmit/student/${reportData.session_id}`;
      const { data } = await instance.get(`${constants.API_BASE_URL}${uri}`);
      return data;
    });
  },

  async fetchDueFees(classId, sessionId) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();

      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/reports/duefees/${sessionId}/${classId ? classId : undefined
        }`
      );
      return data;
    });
  },

  async getAttendanceMasterRecords() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/attendance_master"}`
      );

      if (data.length > 0) {
        return data;
      }
    });
  },

  async addAttendanceMasterRecords(record) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/attendance_master"}`,
        record
      );
      return data;
    });
  },

  async updateAttendanceMasterRecords(record) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/attendance_master/" + record.id}`,
        record
      );
      return data;
    });
  }, // attendance master || END

  async getAttendanceRecords() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/attendance"}`
      );

      if (data.length > 0) {
        return data;
      }
    });
  },

  async getAttendanceRecordByMonthAndYear(record) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL +
        "/api/attendance/attInfo?id=" +
        record.id +
        "&month=" +
        record.month +
        "&year=" +
        record.year
        }`
      );

      return data;
    });
  },
  async addAttendanceRecords(record) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/attendance"}`,
        record
      );
      return data;
    });
  },

  async getAttendanceRecordById(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/attendance/"}` + id
      );
      return data;
    });
  },

  async updateAttendanceRecords(record) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/attendance/" + record.id}`,
        record
      );
      return data;
    });
  }, //attendance || END

  async fetchAttendanceFilterByData(studentid, session_id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/attendance_line_item/studentid/${studentid}/session_id/${session_id}`
      );
      return data;
    });
  },

  async getAttendanceByStudentId(student_id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/attendance/student_id/${student_id}`
      );
      return data;
    });
  },

  async getAttendanceLineItemRecords(record) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL +
        "/api/attendance_line_item?class_id=" +
        record.classid +
        "&section_id=" +
        record.sectionid +
        "&date=" +
        record.date
        }`
      );

      return data;
    });
  },

  async getAttendanceByMonthly(class_id, section_id, month, sessions) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/attendance/class_id/${class_id}/section_id/${section_id}/month/${month}/sessions/${sessions}`
      );

      return data;
    });
  },
  async getAttendanceAllRecordForMonthly(id, year) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();

      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/attendance/attInfo/${id}/${year}`
      );
      return data;
    });
  },
  async updateMultiAttRec(record) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/attendance/update_att/data"}`,
        record
      );
      return data;
    });
  },

  async getStudentAdmissionRecords(record) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const response = await instance.get(
        `${constants.API_BASE_URL}/api/studentaddmissions/getbyids?class_id=${record.classid}&section_id=${record.sectionid}&sessions=${record.sessions}`
      );
      return response.data;
    });
  },

  async addAttendanceLineItemRecords(record) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/attendance_line_item"}`,
        record
      );
      return data;
    });
  },

  async updateMultiAttLineItmRec(record) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/attendance_line_item/multiItms"}`,
        record
      );

      return data;
    });
  },

  async updateAttendanceLineItemRecords(record) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/attendance_line_item/" + record.id}`,
        record
      );

      return data;
    });
  },
  async getStudentRecords(record) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/students/getbyids/${record.classid}?section_id=${record.sectionid}`
      );

      return data;
    });
  },
  async getSectionRecordById(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/section/class/" + id}`
      );
      return data;
    });
  },
  async checkDuplicacy(student) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        constants.API_BASE_URL + "/api/students/dupli/",
        student
      );
      return data;
    });
  },

  async createContOnRecType(contact) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/contacts/parentsData"}`,
        contact
      );
      return data;
    });
  },

  async fetchStudentAddmissionById(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/studentaddmissions/" + id}`
      );
      return data;
    });
  },

  async fetchClasses() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/classes/"}`
      );

      if (data.length > 0) {
        return data;
      }
    });
  },

  async saveStudentAddmission(studentaddmission) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL +
        "/api/studentaddmissions/" +
        studentaddmission.id
        }`,
        studentaddmission
      );
      return data;
    });
  },

  async deleteStudentAddmission(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.delete(
        `${constants.API_BASE_URL + "/api/studentaddmissions/" + id}`
      );
      return data;
    });
  },

  async fetchVehicles() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();

      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/transportation/vehiclesRte"}`
      );

      return data;
    });
  },

  async createStudentAddmission(studentaddmission) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/studentaddmissions/"}`,
        studentaddmission
      );
      return data;
    });
  },

  async createTransportVehicle(vehicle) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/transportation/vehicle"}`,
        vehicle
      );
      return data;
    });
  },

  /** share link (no login) for a fee receipt or published report card: { type, deposit_id } | { type, publish_id } | { type, student_addmission_id, sessionid } */
  // ---- misc income / expense (ledger) ----
  async ledgerGet(path, params) {
    const instance = getAxios();
    const { data } = await instance.get(`${constants.API_BASE_URL}/api/ledger${path}`, { params });
    return data;
  },
  async ledgerPost(path, body) {
    const instance = getAxios();
    const { data } = await instance.post(`${constants.API_BASE_URL}/api/ledger${path}`, body);
    return data;
  },
  async ledgerPut(path, body) {
    const instance = getAxios();
    const { data } = await instance.put(`${constants.API_BASE_URL}/api/ledger${path}`, body);
    return data;
  },

  // ---- result hold for fee due ----
  async getResultBlock(admissionId) {
    const instance = getAxios();
    const { data } = await instance.get(`${constants.API_BASE_URL}/api/result-block/${admissionId}`);
    return data;
  },
  async saveResultBlock(admissionId, body) {
    const instance = getAxios();
    const { data } = await instance.put(`${constants.API_BASE_URL}/api/result-block/${admissionId}`, body);
    return data;
  },

  // ---- head-wise discount ----
  async getHeadDiscountSetting() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(`${constants.API_BASE_URL}/api/settings/fee_head_wise_discount`);
      const rows = Array.isArray(data?.data) ? data.data : Array.isArray(data) ? data : [];
      const row = rows.find((r) => r.key === "fee_head_wise_discount");
      return !!row && String(row.value) === "true";
    });
  },
  async getInstallmentHeadDiscounts(installmentId) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/studentfeeinstallments/installment/${installmentId}/head-discounts`
      );
      return data;
    });
  },
  async saveInstallmentHeadDiscounts(installmentId, heads) {
    const instance = getAxios();
    const { data } = await instance.put(
      `${constants.API_BASE_URL}/api/studentfeeinstallments/installment/${installmentId}/head-discounts`,
      { heads }
    );
    return data;
  },
  async getStudentHeadDiscounts(admissionId, sessionId) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/studentfeeinstallments/${admissionId}/head-discounts` +
          (sessionId ? `?session_id=${sessionId}` : "")
      );
      return data;
    });
  },
  async saveStudentHeadDiscounts(admissionId, installments, sessionId) {
    const instance = getAxios();
    const { data } = await instance.put(
      `${constants.API_BASE_URL}/api/studentfeeinstallments/${admissionId}/head-discounts` +
        (sessionId ? `?session_id=${sessionId}` : ""),
      { installments }
    );
    return data;
  },

  async createShareLink(body) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(`${constants.API_BASE_URL}/api/share-link`, body);
      if (data?.url_path) data.url = `${window.location.origin}${data.url_path}`;
      return data;
    });
  },

  async fetchStudentAddmission(session_id, student_id, status) {
    console.log("sssssssss", student_id, session_id)
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/studentaddmissions/admission/session_id/${session_id}/student_id/${student_id}` +
          (status ? `?status=${encodeURIComponent(status)}` : "")
      );

      return data;
    });
  },


  async fetchAdmissionByStudentId(student_id) {
    console.log("daaaaaaaaaaaaaaa", student_id)
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/studentaddmissions/student_id/${student_id}`
      );
      return data;
    });
  },

  async createPreviousSchool(preSchool) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/previousSchool"}`,
        preSchool
      );
      return data;
    });
  },

  async fetchPreviousSchoolById(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();

      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/previousSchool/" + id}`
      );

      return data;
    });
  },

  async savePreviousSchool(priviousSchool) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/previousSchool/" + priviousSchool.id
        }`,
        priviousSchool
      );

      return data;
    });
  },

  async checkDuplicatContact(contact) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        constants.API_BASE_URL + "/api/contacts/dupli/",
        contact
      );
      return data;
    });
  },

  async checkStudentDuplicacy(student) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        constants.API_BASE_URL + "/api/students/dupli/",
        student
      );
      return data;
    });
  },

  async checkContactDuplicacy(familyInfo) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        constants.API_BASE_URL + "/api/contacts/dupli/",
        familyInfo
      );
      return data;
    });
  },

  async getAllRoute() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/route/getroute"}`
      );
      return data;
    });
  },

  async createRoute(formData) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/route/createroute"}`,
        formData
      );
      return data;
    });
  },

  async deleteRoute(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.delete(
        `${constants.API_BASE_URL + "/api/route/deleteroute/" + id} `
      );
      return data;
    });
  },

  async updateRoute(routeId, formData) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const url = `${constants.API_BASE_URL}/api/route/routeupdate/${routeId} `;
      const { data } = await instance.put(url, formData);
      return data;
    });
  },

  async createAssignment(assignment) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/assignment/"}`,
        assignment
      );
      return data;
    });
  },

  async updateAssignment(id, assignment) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/assignment/" + id}`,
        assignment
      );
      return data;
    });
  },

  async getAllAssignment() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/assignment/assignments"}`
      );
      return data;
    });
  },

  async fetchFileById(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/files/${id}`
      );
      return data;
    });
  },

  async deleteAssignment(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.delete(
        `${constants.API_BASE_URL + "/api/assignment/" + id}`
      );
      return data;
    });
  },

  async fetchNotifications(userId) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/notifications/user/${userId}`
      );
      return data;
    });
  },

  async fetchUnreadCount(userId) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/notifications/unread-count/${userId}`
      );
      return data;
    });
  },

  async markNotificationRead(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL}/api/notifications/mark-read/${id}`
      );
      return data;
    });
  },

  async markAllNotificationsRead(userId) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL}/api/notifications/mark-all-read/${userId}`
      );
      return data;
    });
  },

  async fetchTasks() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(`${constants.API_BASE_URL}/api/tasks`);
      return data;
    });
  },

  async fetchTaskById(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(`${constants.API_BASE_URL}/api/tasks/${id}`);
      return data;
    });
  },

  async createTask(taskData, assignedUserIds) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(`${constants.API_BASE_URL}/api/tasks`, {
        task: taskData,
        assignedUserIds
      });
      return data;
    });
  },

  async updateTask(id, taskData, assignedUserIds) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(`${constants.API_BASE_URL}/api/tasks/${id}`, {
        task: taskData,
        assignedUserIds
      });
      return data;
    });
  },

  async deleteTask(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.delete(`${constants.API_BASE_URL}/api/tasks/${id}`);
      return data;
    });
  },

  async updateTaskUserStatus(taskId, userId, status, file_id = null, description = null, admin_comment = null) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(`${constants.API_BASE_URL}/api/tasks/${taskId}/user/${userId}/status`, { status, file_id, description, admin_comment });
      return data;
    });
  },
  async updateAllFeeHeadMaster(feeHeadMasterRecord) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/feesheadmaster/updateall"}`,
        feeHeadMasterRecord
      );

      return data;
    });
  },

  async deleteFeeMaster(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.delete(
        `${constants.API_BASE_URL + "/api/feemasters/" + id} `
      );
      return data;
    });
  },

  async updateFeeMasterLine(id, newTitle) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/feemasterline/" + id}`,
        newTitle
      );
      if (data.success) {
        return data;
      }
      return null;
    });
  },

  async updateFee(Id, feeMaster) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const url = `${constants.API_BASE_URL}/api/feemasters/${Id} `;
      const { data } = await instance.put(url, feeMaster);
      return data;
    });
  },

  async fetchFeesHeadMaster() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();

      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/feesheadmaster/"}`
      );

      return data;
    });
  },

  async createFeeMaster(feeMaster) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/feemasters"}`,
        feeMaster
      );
      return data;
    });
  },

  async updateFeeMaster(id, assignment) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/assignment/" + id}`,
        assignment
      );
      return data;
    });
  },

  async fetchFeeMaster(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      let query = `${constants.API_BASE_URL + "/api/feemasters/"}`;

      if (id) {
        query += `${id}`;
      }

      const { data } = await instance.get(query);

      return data;
    });
  },

  async fetchFeeMasterByIdOrClassid(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/feemasters/" + id}`
      );
      return data;
    });
  },

  async updateFeeHeadMaster(id, newfeeHeadMasterRecord) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/feesheadmaster/" + id}`,
        newfeeHeadMasterRecord
      );

      if (data.success) {
        return data.record;
      }
      return null;
    });
  },

  async getHeadMastersByStatus(status) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/feesheadmaster/status/" + status}`
      );
      if (data.success) return data.result;
    });
  },

  async deleteFeeHeadMaster(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.delete(
        `${constants.API_BASE_URL + "/api/feesheadmaster/" + id}`
      );
      return data;
    });
  },

  async deleteFeeMasterInstallment(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.delete(
        `${constants.API_BASE_URL + "/api/feemasterline/" + id}`
      );
      return data;
    });
  },
  async getMasterInstallmentByFeeMasterId(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/feemasterline/get/" + id}`
      );
      if (data.success) {
        return data.result;
      }
    });
  },
  async fetchFeeMasterLineItem() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/feemasterline"}`
      );
      if (data.success) {
        return data.result;
      }
    });
  },
  async createFeeMasterLineItem(feeMaster) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/feemasterline"}`,
        feeMaster
      );
      return data;
    });
  },

  async deleteFeeMasterLineItem(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.delete(
        `${constants.API_BASE_URL + "/api/feeinstallineitems/" + id}`
      );
      return data;
    });
  },
  async getLineItemsByFeeMasterId(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/feeinstallineitems/" + id}`
      );
      if (data.success) {
        return data.result;
      }
      return null;
    });
  },
  async fetchFeeInstallmentLineItems() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/feeinstallineitems/"}`
      );
      return data;
    });
  },

  async createFeeInstallmentLineItems(feeHeadLineItem) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/feeinstallineitems/"}`,
        feeHeadLineItem
      );
      return data;
    });
  },
  async assignfeemasterRecord(feeHeadLineItem) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL +
        "/api/feeinstallineitems/feemasterid/" +
        feeHeadLineItem
        }`,
        feeHeadLineItem
      );
      if (data.success) {
        return data;
      }
      return data;
    });
  },
  async updateFeeInstallmentLineItems(feeHeadLineItem) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/feeinstallineitems/"}`,
        feeHeadLineItem
      );
      if (data.success) {
        return data;
      }
      return data;
    });
  },

  async fetchFeeInstallmentsByClassIdAndMonth(admissionid, sessionid) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL +
        "/api/feeinstallineitems/" +
        admissionid +
        "/" +
        sessionid
        }`
      );
      return data;
    });
  },

  async getallIntsallment(admissionid, sessionid, masterinstid) {
    return await this.handleUnauthorized(async () => {
      console.log(
        "calling fee_master_id",
        admissionid,
        sessionid,
        masterinstid
      );
      const instance = getAxios();
      const url = masterinstid
        ? `${constants.API_BASE_URL}/api/studentfeeinstallments/installments/${admissionid}/${sessionid}/${masterinstid}`
        : `${constants.API_BASE_URL}/api/studentfeeinstallments/installments/${admissionid}/${sessionid}`;

      const { data } = await instance.get(url);
      return data;
    });
  },

  async fetchRelatedInstallments(classid, type, structure, sessionid) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL +
        "/api/feeinstallineitems/classid/" +
        classid +
        "/type/" +
        type +
        "/structure/" +
        structure +
        "/sessionid/" +
        sessionid
        }`
      );
      if (data.success) {
        return data.result;
      }
      return null;
    });
  },

  async createStudentFeeInstallments(installmentRecords) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/studentfeeinstallments/"}`,
        installmentRecords
      );
      return data;
    });
  },

  async fetchStudentFeeInstallments(id) {
    console.log("fetching installments for admission id:", id);
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();

      let uri = `${constants.API_BASE_URL + "/api/studentfeeinstallments/view/" + id
        }`;

      const { data } = await instance.get(uri);
      return data;
    });
  },

  async fetchfeesChartdata(session_id) {
    try {
      return await this.handleUnauthorized(async () => {
        const instance = getAxios();

        const { data } = await instance.get(
          `${constants.API_BASE_URL}/api/feedeposites/fees/${session_id}`
        );
        return data;
      });
    } catch (error) {
      throw error;
    }
  },
  async saveFeeDeposit(feeDepositEdit) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/deposits/" + feeDepositEdit.id}`,
        feeDepositEdit
      );
      return data;
    });
  },
  async FeeDepositOnline(amount) {
    try {
      return await this.handleUnauthorized(async () => {
        const instance = getAxios();
        const { data } = await instance.post(
          `${constants.API_BASE_URL + "/api/feedeposites/onlinepayment"}`,
          { amount }
        );
        return data;
      });
    } catch (error) {
      console.error("Error during fatch:", error);
      toast.error(error.response.data.message);
    }
  },

  async fetchFeeDeposit() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/deposits/"}`
      );

      if (data.length > 0) {
        return data;
      }
    });
  },

  async fetchFeeDepositByStudentAddmissionId(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/deposits/studentaddmission/" + id}`
      );
      return data;
    });
  },

  async fetchFeeDepositById(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/deposits/" + id}`
      );
      return data;
    });
  },

  async fetchFeeDepositByStudentId(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/deposits/studentaddmission/" + id}`
      );
      return data;
    });
  },

  async createFeeDeposit(feeDeposit) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/feedeposites/"}`,
        feeDeposit
      );
      return data;
    });
  },

  async fetchFeeDepositsByStudentId(
    studentAddmissionid,
    session_id,
    deposit_id
  ) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      let uri = `/api/feedeposites/studentaddmission/${studentAddmissionid}/${session_id}`;
      if (deposit_id) {
        uri += `/${deposit_id}`;
      }

      const { data } = await instance.get(`${constants.API_BASE_URL}${uri}`);
      return data;
    });
  },

  async fetchClassRecordsFeeDeposit(classid, session_id, startdate, enddate) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      let uri = `/api/reports/feedepositreport/${classid ? classid : "null"
        }/${session_id}`;

      const { data } = await instance.get(`${constants.API_BASE_URL}${uri}`, {
        params: { startdate: startdate, enddate: enddate },
      });
      return data;
    });
  },

  async fetchFeeDepositsById(id) {
    try {
      return await this.handleUnauthorized(async () => {
        const instance = getAxios();
        const { data } = await instance.get(
          `${constants.API_BASE_URL + "/api/feedeposites/" + id}`
        );
        return data;
      });
    } catch (error) {
      console.error("Error during fatch:", error);
      toast.error(error.response.data.message);
    }
  },

  async updateFeeDepositsById(id, depositeRecord) {
    try {
      return await this.handleUnauthorized(async () => {
        const instance = getAxios();
        const { data } = await instance.put(
          `${constants.API_BASE_URL + "/api/feedeposites/" + id}`,
          depositeRecord
        );
        return data;
      });
    } catch (error) {
      console.error("Error during fatch:", error);
      toast.error(error.response.data.message);
    }
  },

  async cancelFeeReceipt(id, admissionid, student_id) {
    try {
      return await this.handleUnauthorized(async () => {
        const instance = getAxios();
        const { data } = await instance.put(
          `${constants.API_BASE_URL +
          "/api/feedeposites/cancel/" +
          id +
          "/" +
          admissionid +
          "/" +
          student_id
          }`
        );
        return data;
      });
    } catch (error) {
      return toast.error("Internel server error");
    }
  },

  async deleteFeeDeposite(id) {
    try {
      return await this.handleUnauthorized(async () => {
        const instance = getAxios();
        const { data } = await instance.delete(
          `${constants.API_BASE_URL + "/api/feedeposites/" + id}`
        );
        return data;
      });
    } catch (error) {
      console.error("Error during fatch:", error);
      toast.error(error.response.data.message);
    }
  },

  async fetchFeeDiscounts(id, status) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      let url = `${constants.API_BASE_URL}/api/discount`;
      if (id && id !== "undefined" && id !== "null") {
        url += `/${id}`;
      }
      if (status && status !== "undefined" && status !== "null") {
        url += `?status=${encodeURIComponent(status)}`;
      }
      const { data } = await instance.get(url);
      return data;
    });
  },
  async fetchFeeDiscountsById(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/discount/" + id}`
      );
      return data;
    });
  },
  async checkFeeInstallmentlineitem(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/feesheadmaster/feelineitem/" + id}`
      );
      return data;
    });
  },

  async createFeeDiscounts(record) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/discount/"}`,
        record
      );
      return data;
    });
  },

  async updateFeeDiscounts(id, record) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/discount/" + id}`,
        record
      );
      return data;
    });
  },

  async deleteFeeDiscounts(id, record) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.delete(
        `${constants.API_BASE_URL + "/api/discount/" + id}`
      );
      return data;
    });
  },

  async createFeeDiscountLineItems(record) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/discount-line-items"}`,
        record
      );
      return data;
    });
  },

  async fetchPendingAmount(record) {
    try {
      return await this.handleUnauthorized(async () => {
        const instance = getAxios();
        const { data } = await instance.get(
          `${constants.API_BASE_URL +
          "/api/feedeposites/dues/" +
          record?.student_addmission_id
          }`
        );
        return data;
      });
    } catch (error) {
      console.error("Error during fatch:", error);
      toast.error(error.response.data.message);
    }
  },

  async fetchFeeDiscountLineItemsBySt(studentAdmissionId) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL +
        "/api/discount-line-items/" +
        studentAdmissionId
        }`
      );
      return data;
    });
  },

  async updateFeeDiscountLineItems(record) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/discount-line-items/"}`,
        record
      );
      return data;
    });
  },

  async getAllModules(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/modulemaster/getmodule/" + id}`
      );
      return data;
    });
  },

  async createModule(module) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/modulemaster/create"}`,
        module
      );
      return data;
    });
  },

  async updateAllParentmodule(modules) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/modulemaster/updateAll/"}`,
        modules
      );
      return data;
    });
  },

  async deleteModule(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.delete(
        `${constants.API_BASE_URL + "/api/modulemaster/delete/" + id}`
      );
      return data;
    });
  },

  async updateModule(id, module) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/modulemaster/updatebyid/" + id}`,
        module
      );
      return data;
    });
  },

  async createPermission(permission) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/permission/create"}`,
        permission
      );
      return data;
    });
  },

  async updatePermission(id, permission) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/permission/updatebyid/" + id}`,
        permission
      );
      return data;
    });
  },

  async deletePermission(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.delete(
        `${constants.API_BASE_URL + "/api/permission/deletepermissionbyid/" + id
        }`
      );
      return data;
    });
  },

  async createRole(role) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/rolemaster/create"}`,
        role
      );
      return data;
    });
  },

  async getAllRoles() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/rolemaster/getrole"}`
      );
      return data;
    });
  },

  async deleteRoles(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.delete(
        `${constants.API_BASE_URL + "/api/rolemaster/deleterolebyid/" + id}`
      );
      return data;
    });
  },
  async deleteRolePermission(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.delete(
        `${constants.API_BASE_URL + "/api/rolepermission/deletebyid/" + id}`
      );
      return data;
    });
  },

  async updateRole(id, role) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/rolemaster/updatebyid/" + id}`,
        role
      );
      return data;
    });
  },

  async getRolePermission(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/permissions/${id}`
      );
      return data;
    });
  },

  async upsertRolePermissions(rolePermissions) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL}/api/permissions/`,
        rolePermissions
      );

      return data;
    });
  },

  async getAllRolePermission() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/rolepermission/getrole_permission`
      );
      return data;
    });
  },

  async createRolePermission(rolePermission) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL}/api/rolepermission/create`,
        rolePermission
      );
      return data;
    });
  },

  async updateRolePermission(rolePermission) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL}/api/rolepermission/updaterolepermissionbyid`,
        rolePermission
      );
      return data;
    });
  },

  async getAllPermission() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/rolepermission/getallpermission`
      );
      if (data.length > 0) {
        return data;
      }
    });
  },

  async createTimeSlot(timeslot) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/timeslots"}`,
        timeslot
      );
      return data;
    });
  },

  async fetchTimeSlot() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/timeslots/"}`
      );

      return data;
    });
  },

  async updateTimeSlot(timeSlot) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/timeslots/" + timeSlot.id}`,
        timeSlot
      );
      return data;
    });
  },

  async deleteTimeSlot(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.delete(
        `${constants.API_BASE_URL + "/api/timeslots/" + id}`
      );
      return data;
    });
  },

  async createTimetable(timetable) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/timetable/"}`,
        timetable
      );
      return data;
    });
  },

  async upsertTimetable(timetables) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/timetable/"}`,
        timetables
      );
      return data;
    });
  },

  async createTimetableOnEdit(timetable) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/timetable/onEditInsert"}`,
        timetable
      );
      return data;
    });
  },

  async fetchTimetable(type) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/timetable/${type}`
      );
      return data;
    });
  },

  async fetchTimetableByTeacher(contactId, currentYearId) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/timetable/teacher/${contactId}/${currentYearId}`
      );
      return data;
    });
  },

  async fetchTimetableByTeacherId(type, contactid, currentYearId) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/timetable/teacher/${type}/${contactid}/${currentYearId}`
      );
      if (data.length > 0) {
        return data;
      }
    });
  },

  async fetchTimetableByClassId(classid, currentYearId) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/timetable/${classid}/${currentYearId}`
      );
      if (data.length > 0) {
        return data;
      }
    });
  },

  async fetchTimetableRecords(classId = null, sectionId = null) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/timetable/classid/${classId}/sectionid/${sectionId}`
      );

      return data;
    });
  },

  async fetchTimetableBySectionId(sectionid, currentYearId, type) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/timetable/class/${sectionid}/${currentYearId}/${type}`
      );
      if (data.length > 0) {
        return data;
      }
    });
  },

  async fetchTimetableByIds(timeslot) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/timetable/timeslot/${timeslot}`
      );
      if (data.length > 0) {
        return data;
      }
    });
  },

  async getTimeTable(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/timetable/" + id}`
      );
      return data;
    });
  },

  async getTimeTableTeacherRec(contactId) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/timetable/teacher/${contactId}`
      );
      return data;
    });
  },

  async deleteTimeTable(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.delete(
        `${constants.API_BASE_URL + "/api/timetable/" + id}`
      );

      return data;
    });
  },

  async getTimeTableRecord(classId, sectionId) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/timetable/class/${classId}/${sectionId}`
      );
      return data;
    });
  },

  async getTimeTableForStudent(classId, month, sessionId, studentAdd) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/attendance_line_item/${classId}/${month}/${sessionId}/${studentAdd}`
      );
      return data;
    });
  },

  async updateTimeTable(timetable) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/timetable/update"}`,
        timetable
      );
      return data;
    });
  },

  async CreateQuickLauncher(vl) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/quicklaucher"}`,
        vl
      );
      return data;
    });
  },

  async getAllQuickLauncher() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/quicklaucher"}`
      );
      return data;
    });
  },

  async deletQuickLaucher(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.delete(
        `${constants.API_BASE_URL + "/api/quicklaucher/" + id}`
      );
      return data;
    });
  },

  async getBooksRecords() {
    return this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/books`
      );

      if (data) return data;
      return null;
    });
  },

  async getBooksRecordsById(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/books/" + id}`
      );

      return data;
    });
  },

  async addBookRecord(records) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/books"}`,
        records
      );
      return data;
    });
  },

  async updateBookRecord(records) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/books/" + records.id}`,
        records
      );
      return data;
    });
  },

  async deleteBook(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.delete(
        `${constants.API_BASE_URL + "/api/books/" + id}`
      );

      return data;
    });
  },

  async getAuthorsRecords() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();

      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/authors`
      );

      return data;
    });
  },

  async createAuthor(records) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/authors"}`,
        records
      );
      return data;
    });
  },
  async updateAuthor(records) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/authors/" + records.id}`,
        records
      );
      return data;
    });
  },

  async deleteAuthor(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.delete(
        `${constants.API_BASE_URL + "/api/authors/" + id}`
      );

      return data;
    });
  },

  async getCategoryRecords() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();

      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/category`
      );

      return data;
    });
  },
  async createCategory(records) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/category"}`,
        records
      );
      return data;
    });
  },

  async updateCategory(records) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/category/" + records.id}`,
        records
      );
      return data;
    });
  },

  async deleteCategory(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.delete(
        `${constants.API_BASE_URL + "/api/category/" + id}`
      );

      return data;
    });
  },

  async getPublishersRecords() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/publishers`
      );
      return data;
    });
  },

  async createPublisher(records) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/publishers"}`,
        records
      );
      return data;
    });
  },

  async updatePublisher(records) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/publishers/" + records.id}`,
        records
      );
      return data;
    });
  },

  async deletePublisher(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.delete(
        `${constants.API_BASE_URL + "/api/publishers/" + id}`
      );

      return data;
    });
  },

  async getLanguagesRecords() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();

      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/languages`
      );

      return data;
    });
  },

  async createLanguage(records) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/languages"}`,
        records
      );
      return data;
    });
  },

  async updateLanguage(records) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/languages/" + records.id}`,
        records
      );
      return data;
    });
  },

  async deleteLanguage(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.delete(
        `${constants.API_BASE_URL + "/api/languages/" + id}`
      );
      return data;
    });
  },

  async getPurchasesRecords() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/purchases`
      );

      return data;
    });
  },

  async getPurchasesRecordsByBookId(book_id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/purchases/" + book_id}`
      );
      return data;
    });
  },

  async createPurchase(records) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/purchases"}`,
        records
      );
      return data;
    });
  },

  async updatePurchase(records) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/purchases/" + records.id}`,
        records
      );
      return data;
    });
  },

  async deletePurchase(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.delete(
        `${constants.API_BASE_URL + "/api/purchases/" + id}`
      );
      return data;
    });
  },

  async getSupplierRecords() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/suppliers`
      );
      return data;
    });
  },

  async createSupplier(records) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/suppliers"}`,
        records
      );
      return data;
    });
  },

  async updateSupplier(records) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/suppliers/" + records.id}`,
        records
      );
      return data;
    });
  },
  async deleteSupplier(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.delete(
        `${constants.API_BASE_URL + "/api/suppliers/" + id}`
      );
      return data;
    });
  },

  async getIssuesRecords() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/issues"}`
      );

      return data;
    });
  },

  async getIsuueRecordsById(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/issues/" + id}`
      );
      return data;
    });
  },

  async getIssueRecordsByBookId(book_id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/issues/bookid/" + book_id}`
      );
      return data;
    });
  },

  async createIssue(records) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/issues"}`,
        records
      );
      return data;
    });
  },

  async updateIssue(records) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/issues/" + records.id}`,
        records
      );
      return data;
    });
  },

  async getBooksRecordsBylanguageId(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/books/languageId/" + id}`
      );
      return data;
    });
  },

  async getBooksRecordsBycategoryId(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();

      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/books/categoryId/${id}`
      );

      return data;
    });
  },

  async getBooksRecordsByPublisherId(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();

      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/books/publisherId/" + id}`
      );

      return data;
    });
  },

  async getAuthorById(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/authors/" + id}`
      );
      return data;
    });
  },

  async getBooksByAuthorId(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/authors/books/" + id}`
      );
      return data;
    });
  },

  async getPurchasesRecordsBysupplierId(supplierId) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/purchases/supplierId/" + supplierId}`
      );
      return data;
    });
  },

  async getSupplierRecordsById(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/suppliers/" + id}`
      );
      return data;
    });
  },

  async getAllSubByClassId(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL +
        "/api/assignsubjectclass/getallsubclsid/" +
        id
        }`
      );
      return data;
    });
  },

  async updateAssignSubjectClassRecord(records) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL +
        "/api/assignsubjectclass/" +
        records.assign_subject_id
        }`,
        records
      );
      return data;
    });
  },

  async getAllRolesByCompanyId(companyId) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL +
        "/api/rolemaster/getrolebyCompanyId/" +
        companyId
        }`
      );
      return data;
    });
  },

  async getRolePermissionByIds() {
    let permissiontoken = "";
    if (sessionStorage.getItem("token")) {
      permissiontoken = sessionStorage.getItem("token");
    }
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/permissions/getby/ids"}`,
        { headers: { permissiontoken } }
      );
      return data;
    });
  },

  async fetchUsersbyCompanyId() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/auth/findbycompanyid"}`
      );

      return data;
    });
  },

  async fetchAllPublicUsers() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/auth/public"}`
      );
      return data;
    });
  },

  async createUserbyCompanyId(records) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/auth/createuser"}`,
        records
      );
      if (data.success) {
        return data;
      }
      return null;
    });
  },

  async updateUser(records) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/auth/user/" + records.id}`,
        records
      );
      return data;
    });
  },

  async getStudentResult(classId, admissionId) {
    const instance = getAxios();
    return await this.handleUnauthorized(async () => {
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/results/" + classId + "/" + admissionId
        }`
      );

      return data;
    });
  },
  async getFinalDataByClassAndSesionId(class_id, session_id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL +
        "/api/promotion/" +
        class_id +
        "/" +
        session_id
        }`
      );

      return data;
    });
  },

  async promtionStudentAddmission(studentPromotion) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/promotion/"}`,
        studentPromotion
      );
      return data;
    });
  },

  async fetchPromotionFeeMasterByIdOrClassid(id, session_id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/promotion/fee_master/${id}/${session_id}`
      );
      return data;
    });
  },

  async updateStudentStatus(students) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL}/api/promotion/`,
        students
      );

      return data;
    });
  },

  async fetchUsersRecords(stu_admission_id, parent_id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/auth/${stu_admission_id}/${parent_id}`
      );

      return data;
    });
  },

  async createAnouncement(ann_details) {
    console.log('ann_details-on school api->', ann_details);
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/anouncements"}`,
        ann_details
      );
      return data;
    });
  },

  async sendPushNotification(notificationDetails) {
    // console.log('ann_details-on school api->',userDetails);
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/anouncements/send-notification"}`,
        notificationDetails
      );
      return data;
    });
  },

  async updateAnouncement(ann_details) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL}/api/anouncements/${ann_details.id}`,
        ann_details
      );
      return data;
    });
  },

  async getAnnouncementUsers(announcementId) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/anouncements/${announcementId}/users`
      );
      return data;
    });
  },

  async getAllAnouncement() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/anouncements`
      );
      return data;
    });
  },

  async fetchAnouncementById(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/anouncements/" + id}`
      );
      return data;
    });
  },
  async deleteAnouncement(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.delete(
        `${constants.API_BASE_URL + "/api/anouncements/" + id}`
      );
      return data;
    });
  },
  async getWhatsAppSettingRecord() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();

      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/whatsapp_setting"}`
      );
      return data;
    });
  },
  async updateWhatsAppSettingRecord(settingData) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/whatsapp_setting/" + settingData.id}`,
        settingData
      );
      return data;
    });
  },

  async insertWhatsAppSettingRecords(settingData) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/whatsapp_setting"}`,
        settingData
      );
      return data;
    });
  },

  async getResponseMessageData() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/response_message"}`
      );
      return data;
    });
  },

  async deleteResponseMessageRecord(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.delete(
        `${constants.API_BASE_URL + "/api/response_message/" + id}`
      );
      return data;
    });
  },
  async updateResponseMessageRecord(Record) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/response_message/" + Record.id}`,
        Record
      );
      return data;
    });
  },
  async inserResponseMessageRecord(Record) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/response_message/"}`,
        Record
      );
      return data;
    });
  },

  async getTemplateData() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/webhook_template/alltemplate"}`
      );

      return data;
    });
  },

  async insertCampaignRecords(campiagnData) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/whatsapp/campaign"}`,
        campiagnData
      );

      return data;
    });
  },

  async getCampaignData() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/whatsapp/campaign"}`
      );

      return data;
    });
  },
  //  async createCampaignFile(cpId, formData) {
  //    return await this.handleUnauthorized(async () => {
  //      const instance = getAxios();
  //      const { data } = await instance.post(
  //        `${constants.API_BASE_URL + "/api/whatsapp/campaign/file/" + cpId}`,
  //        formData
  //      );
  //
  //      return data;
  //    });
  //  },
  async createCampaignFile(cpId, formData) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();

      const { data } = await instance.post(
        `${constants.API_BASE_URL}/api/whatsapp/campaign/file/${cpId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data", // Let Axios set boundary automatically
          },
        }
      );

      return data;
    });
  },
  async updateCampaignRecord(campiagnData) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/whatsapp/campaign/" + campiagnData.id
        }`,
        campiagnData
      );

      return data;
    });
  },
  async getMsgHistoryDownload(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL +
        "/api/whatsapp/message/history/download/" +
        id
        }`
      );

      return data;
    });
  },
  async createGroup(formData) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/whatsapp/groups/"}`,
        formData
      );

      return data;
    });
  },
  async fetchGroups(status) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();

      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/whatsapp/groups`,
        { params: { status } }
      );

      return data;
    });
  },
  async deleteGroupRecord(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.delete(
        `${constants.API_BASE_URL + "/api/response_message/" + id}`
      );
      return data;
    });
  },
  async fetchMembersById(Id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/whatsapp/groups/" + Id}`
      );

      return data;
    });
  },
  async deleteGroupMember(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.delete(
        `${constants.API_BASE_URL + "/api/whatsapp/groups/member/" + id}`
      );
      return data;
    });
  },
  async changeGroupStatus(id, status) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/whatsapp/groups/" + id + "/status"}`,
        { status }
      );
      return data;
    });
  },
  async addMoreMembers(id, formData) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/whatsapp/groups/add_members/" + id}`,
        formData
      );
      return data;
    });
  },
  async fetchGroupsById(Id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/whatsapp/groups/" + Id}`
      );

      return data;
    });
  },
  async createMessageTemplateData(formData) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/whatsapp/message/template"}`,
        formData
      );

      return data;
    });
  },
  async getAllcontactwithstudentname(
    type,
    selectedClasses,
    selectedSection,
    SessionID
  ) {
    return await this.handleUnauthorized(async () => {
      try {
        const params = { type, selectedClasses, selectedSection, SessionID };

        const instance = getAxios();

        const { data } = await instance.get(
          `${constants.API_BASE_URL}/api/contacts/withstudentname`,
          { params }
        );

        return data;
      } catch (error) {
        console.error("Error fetching contacts:", error);
        throw error;
      }
    });
  },
  async getallemploye() {
    return await this.handleUnauthorized(async () => {
      try {
        const instance = getAxios();
        const { data } = await instance.get(
          `${constants.API_BASE_URL}/api/contacts/employes`
        );

        return data;
      } catch (error) {
        console.error("Error fetching contacts:", error);
        throw error;
      }
    });
  },

  async getAllcontactwithclassgroup() {
    return await this.handleUnauthorized(async () => {
      try {
        const instance = getAxios();
        const { data } = await instance.get(
          `${constants.API_BASE_URL}/api/contacts/classgroup`
        );
        return data;
      } catch (error) {
        console.error("Error updating contact:", error);
        throw error;
      }
    });
  },
  async updateMarketingTemplate(id, reqBody) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/webhook_template/template/" + id}`,
        reqBody
      );

      return data;
    });
  },
  async createMarketingTemplate(reqBody) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      try {
        const { data } = await instance.post(
          `${constants.API_BASE_URL}/api/webhook_template/template`,
          reqBody
        );

        return data;
      } catch (error) {
        console.error("Error creating marketing template:", error);
        throw new Error(
          `Template creation failed: ${error.response?.data || error.message}`
        );
      }
    });
  },
  async generateSessionId(selectedFiles) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();

      const formData = new FormData();
      if (Array.isArray(selectedFiles)) {
        selectedFiles.forEach((file) => formData.append("files", file));
      } else {
        formData.append("files", selectedFiles);
      }

      try {
        const { data } = await instance.post(
          `${constants.API_BASE_URL}/api/webhook_template`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        return data;
      } catch (error) {
        console.error("Error generating session ID:", error);
        throw new Error(
          `File upload failed: ${error.response?.data || error.message}`
        );
      }
    });
  },
  async uploadDocumentSessionId(selectedFiles, id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const formData = new FormData();

      if (Array.isArray(selectedFiles)) {
        selectedFiles.forEach((file) => formData.append("files", file));
      } else {
        formData.append("files", selectedFiles);
      }
      formData.append("uploadSessionId", id); // Always append this

      try {
        const { data } = await instance.post(
          `${constants.API_BASE_URL}/api/webhook_template/uploadsessionid`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        return data;
      } catch (error) {
        console.error("Upload error:", error);
        throw error; // Propagate the error for further handling
      }
    });
  },
  async upsertAuthTemplate(reqbody) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/webhook_template/temp/auth"}`,
        reqbody
      );

      return data;
    });
  },

  async deleteTemplateRecord(id, name) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.delete(
        `${constants.API_BASE_URL}/api/webhook_template/template?hsm_id=${id}&name=${name}`
      );
      return data;
    });
  },
  async getfeereciptdata(stuid) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/feedeposites/studetnaddid/" + stuid}`
      );
      return data;
    });
  },
  async getFilterData(from, textName, classes, recordType, section, sessionId) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const params = new URLSearchParams({
        from: from || "whatsapp",
        textName: textName || "",
        classes: classes || "",
        recordType: recordType || "",
        sessionId: sessionId || "",
        section: section || "",
      }).toString();
      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/whatsapp/chat/filter?${params}`
      );
      return data;
    });
  },
  async getApprovedTemplates() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/webhook_template/approved/template`
      );
      return data;
    });
  },
  async sendWhatsAppTemplateMessage(reqbody) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL}/api/webhook_template/message`,
        reqbody
      );
      return data;
    });
  },
  async insertMsgHistoryRecords(reqbody) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL}/api/whatsapp/message/history`,
        reqbody
      );
      return data;
    });
  },
  async getMsgHistoryRecords(number) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/whatsapp/message/history/${number}`
      );
      return data;
    });
  },
  async getGroupHistoryRecords(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/whatsapp/group/message/history/${id}`
      );
      return data;
    });
  },
  async sendSingleWhatsAppTextMessage(reqbody) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        constants.API_BASE_URL + "/api/webhook_template/single/message",
        reqbody
      );
      return data;
    });
  },

  async ForgetPasswordApi(credentials) {
    console.log("credentials->", credentials);

    // if (!credentials?.email || !credentials?.school_code) {
    //   throw new Error("Email and school code are required.");
    // }
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL}/api/auth/forgot-password`,
        {
          email: credentials.email,
          school_code: credentials.school_code,
        }
      );

      return data;
    });
  },

  async CheckOtp(email, otp) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL}/api/auth/check-otp`,
        { email, otp }
      );
      return data;
    });
  },

  async ResetPassword(email, password, school_code) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL}/api/auth/updatepassword/user`,
        { email, password, school_code }
      );
      return data;
    });
  },

  async sentNotification(announcemntData) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL}/api/user_device/`,
        announcemntData
      );
      return data;
    });
  },

  async sendSingleWhatsAppTextMessage(reqbody) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        constants.API_BASE_URL + "/api/webhook_template/single/message",
        reqbody
      );
      return data;
    });
  },
  async pdfData(obj) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();

      const { data } = await instance.post(
        `${constants.API_BASE_URL}/api/webhook_template/proxy`,
        obj,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return data;
    });
  },

  async uploadDocumentWithApi(file) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();

      const { data } = await instance.post(
        `${constants.API_BASE_URL}/api/webhook_template/documentId`,
        file,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return data;
    });
  },
  async fetchUnreadMsgCount() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();

      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/whatsapp/chat/unread_count`
      );

      return data;
    });
  },

  async markMessagesAsRead(whatsappNumber) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();

      const { data } = await instance.post(
        `${constants.API_BASE_URL}/api/whatsapp/chat/mark_as_read`,
        { whatsapp_number: whatsappNumber }
      );

      return data;
    });
  },

  async updatetypestatusstudent(record) {
    try {
      return await this.handleUnauthorized(async () => {
        const instance = getAxios();
        const { data } = await instance.put(
          `${constants.API_BASE_URL}/api/students/typestatus/${record.id}`,
          record
        );

        return data;
      });
    } catch (error) {
      console.error("Error updating type status student:", error);
      throw error;
    }
  },
  async checkduplicate(srno, email, id, sessionid) {
    try {
      return await this.handleUnauthorized(async () => {
        const instance = getAxios();
        let baseurl = `${constants.API_BASE_URL}/api/studentaddmissions/srnodulicate`;
        const params = new URLSearchParams();

        // Adding parameters conditionally
        if (srno) {
          params.append("srno", srno);
        }
        if (email) {
          params.append("email", email);
        }
        if (id !== undefined && id !== null) {
          params.append("id", id);
        }
        if (sessionid) {
          params.append("sessionid", sessionid);
        }
        baseurl += `?${params.toString()}`;
        const { data } = await instance.get(baseurl);
        return data;
      });
    } catch (error) {
      console.error("Error updating type status student:", error);
      throw error;
    }
  },
  async checkduplicateuser(email, id) {
    try {
      return await this.handleUnauthorized(async () => {
        const instance = getAxios();
        console.log("email, id ->", email, id);

        let baseurl = `${constants.API_BASE_URL}/api/studentaddmissions/useremail/${email}`;

        baseurl += `/${id}`;

        const { data } = await instance.get(baseurl);
        return data;
      });
    } catch (error) {
      console.error("Error updating type status student:", error);
      throw error;
    }
  },
  async getStudentResultByclsIdAdmissionId(
    commanClassId,
    studentsRecordsArray
  ) {
    try {
      return await this.handleUnauthorized(async () => {
        const instance = getAxios();
        const { data } = await instance.post(
          `${constants.API_BASE_URL}/api/promotion/studentResult/${commanClassId}`,
          studentsRecordsArray
        );
        return data;
      });
    } catch (error) {
      console.error("Error updating type status student:", error);
      throw error;
    }
  },

  async getPromotedActiveClasses(sessionid) {
    try {
      return await this.handleUnauthorized(async () => {
        const instance = getAxios();
        const { data } = await instance.get(
          `${constants.API_BASE_URL}/api/promotion/promoteClasses/${sessionid}`
        );
        return data;
      });
    } catch (error) {
      console.error("Error getting promoted classes:", error);
      throw error;
    }
  },

  /* 04-march-2025 | create employee with doc. */
  async createContactwithdoc(contact) {
    const formData = new FormData();
    Object.keys(contact).forEach((key) => {
      if (Array.isArray(contact[key])) {
        contact[key].forEach((item, index) => {
          Object.keys(item).forEach((subKey) => {
            formData.append(
              `previousEmployers[${index}][${subKey}]`,
              item[subKey]
            );
          });
        });
      } else {
        if (contact[key] !== null && contact[key] !== undefined) {
          if (key === "dateofbirth") {
            formData.append(key, formatLocalDateForApi(contact[key]));
          } else {
            formData.append(key, contact[key]);
          }
        }
      }
    });

    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL}/api/contacts/document`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      return data;
    });
  },




  /* sarfraj | 06-march-2025 */
  async updateEmployeeWithDocument(employee) {
    const formData = new FormData();

    Object.keys(employee).forEach((key) => {
      console.log('key-->>', key);

      if (Array.isArray(employee[key]) && key === "previousEmployers") {
        employee[key].forEach((item, index) => {
          Object.keys(item).forEach((subKey) => {

            let value = item[subKey];
            // If the field is 'experience_letter' and it's an object, stringify it
            if (subKey === "experience_letter" && typeof value === "object" && !(value instanceof File)) {
              value = JSON.stringify(value);
            }

            formData.append(`previousEmployers[${index}][${subKey}]`, value);
          });
        });
      } else {
        if (employee[key] !== null && employee[key] !== undefined) {
          if (key === "dateofbirth") {
            formData.append(key, formatLocalDateForApi(employee[key]));
          } else {
            formData.append(key, employee[key]);
          }
        }
      }
    });

    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${constants.API_BASE_URL}/api/contacts/document/${employee.id}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      return data;
    });
  },

  // 07 march 2025 | sarfraj
  async deleteEmployerById(employerids) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.delete(`${constants.API_BASE_URL}/api/contacts/employerbyids/id`, {
        data: { employerids }
      });
      return data;
    });
  },

  async insertCampaignParamsRecords(reqbody) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${constants.API_BASE_URL}/api/whatsapp/campaign/params`,
        reqbody
      );
      return data;
    });
  },
  async getTemplateaAmountBySetting(template_id, start, end) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(`${constants.API_BASE_URL}/api/whatsapp_setting/templateprice/${template_id}/${start}/${end}`);
      return data;
    });
  },
  async downloadCampaignFile(file) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      try {
        const response = await instance.get(
          `${constants.API_BASE_URL}/api/whatsapp/campaign/download/${file}`,
          { responseType: "blob" } // Important for binary data
        );

        return response.data;
      } catch (error) {
        console.error("Error fetching filtered student data:", error);
        throw error;
      }
    });
  },

  async historyDelete(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.delete(`${constants.API_BASE_URL}/api/whatsapp/history/${id}`);
      return data;
    });
  },

  async searchStudents(data) {
    console.log("Searching students with data:", data);
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      console.log("Axios instance created for searchStudents", instance);
      const { data: response } = await instance.post(constants.API_BASE_URL + `/api/students/searchStudents`, data);
      console.log("Search response:", response);
      return response;
    });
  },
  /*  END ./  */

  ///////////////////////
  /*   End */

// added Aabid

async updateFile(id, data)  {
  try {
    const instance = getAxios();
    const response = await instance.put(constants.API_BASE_URL + `/api/files/${id}`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}
};
export default schoolApi;
